import APP_CONST from '@/constants/AppConst';
import algoliasearch from 'algoliasearch';

export const AlgoliaClient = algoliasearch(APP_CONST.ALGOLIA_APP_ID, APP_CONST.ALGOLIA_API_KEY);

export const AlgoliaIndex = AlgoliaClient.initIndex(APP_CONST.ALGOLIA_INDEX_NAME);
